<form #loginForm="ngForm">
    <div class="container-loader" *ngIf="isBusy">
      <ngx-loading [show]="isBusy" [config]="loaderConfig"></ngx-loading>
    </div>
    <div class="modal-header">
      <h3 class="modal-title">Forgot Login Details</h3>
      <button type="button" class="close close-modal" data-dismiss="modal" aria-label="Close" (click)="onDecline()">
          <span aria-hidden="true" style="font-size: 25px;">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="modal-body-desc">
        Enter your username below, and we will send you instructions to reset your password.
      </div>
      <div [ngClass]="{'arrow-bottom':true, 'email-validation-has-error' : true, 'show' : isEmptyEmail }">
          <span>Username is required</span>
      </div>
      <div class="flex-group">
        <span class="flex-addon">
            <img src="../../assets/images/profile-circle.png" width="20" height="20">
        </span>
        <input #email autofocus type="text" [ngClass]="{'form-control email-tb': true, 'red-border': isEmptyEmail}" name="username-forgot" placeholder="Username" autocomplete="username-forgot"
        placeholder="Username" id="email" required [disabled]="submitted"/>
      </div>
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-primary confirm-btn" (click)="onConfirm(email.value)" [disabled]="submitted">SUBMIT</button>
    </div>
  </form>